import React from "react";

const Footer = () => {
  return (
    <footer>
      <p className="footer-consultas">
        Tienes consultas o necesitas ayuda, escríbeme a:&nbsp;<br></br>
        <a href="mailto:webmaster.developersblog@yahoo.com">
          webmaster.developersblog@yahoo.com
        </a>
      </p>
      <p className="footer-powered-by">
        <em>
          © {new Date().getFullYear()}, Construido con &nbsp;
          <a href="https://www.gatsbyjs.org">Gatsby</a>
        </em>
      </p>
    </footer>
  );
};

export default Footer;
